import { useState } from 'react'
import { sileo } from 'sileo'
import CustomButton from '../../../../ui/CustomButton'
import PlanRestrictedButton from '../../../../ui/PlanRestrictedButton'

const CrearCentro = ({ onCreate }) => {
  const [nombre, setNombre] = useState('')

  const handleSubmit = async e => {
    e.preventDefault()
    const value = nombre.trim()

    if (!value) {
      sileo.error({
        title: 'Nombre Requerido',
        description: (
          <span className='text-red-500/80 font-medium'>
            Debes ingresar un nombre para el centro de costos
          </span>
        )
      })
      return
    }

    await onCreate(value)
    setNombre('')
  }

  return (
    <div className='p-4 bg-white rounded-3xl shadow-md flex flex-col shrink-0'>
      <h2 className='font-semibold mb-4'>Crear nuevo Centro de Costos</h2>
      <form onSubmit={handleSubmit} className='flex gap-2 items-center'>
        <input
          type='text'
          value={nombre}
          onChange={e => setNombre(e.target.value)}
          placeholder='Nombre del centro de costos'
          className='mt-1 block w-full rounded-full border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm max-w-72'
        />
        <PlanRestrictedButton
          keepEnabled={true}
          requiredPermission="allowCostCenter"
          message="Los centros de costos no están disponibles en tu plan actual. Actualiza tu plan para acceder a esta funcionalidad."
        >
          <CustomButton
            color='primary'
            className='w-56 h-12 bg-primary text-white font-bold rounded-full'
            title='Crear'
          />
        </PlanRestrictedButton>
      </form>
    </div>
  )
}

export default CrearCentro
